import { Component, Input } from '@angular/core';

import { EditableList, ReadingListDetails } from '®shared/reading-list';

@Component({
  selector: 'rl-list-status-review',
  templateUrl: './list-status-review.component.html',
  styleUrls: ['./list-status-review.component.scss'],
})
export class ListStatusReviewComponent {
  @Input() list: ReadingListDetails;
  @Input() editableList: EditableList;
}
